<div class="sheet-header surface-container-lowest">
  <div class="left-action">
    @if ($currentView() === View.DETAILS) {
      <button mat-button class="error-button" (click)="back()">Cancel</button>
    } @else {
      <button mat-button (click)="back()">Back</button>
    }
  </div>

  <span class="pueblo-font headline-large on-surface-text sheet-title">
    Hang
  </span>

  <div class="right-action">
    <button mat-flat-button [disabled]="$isNextDisabled()" (click)="next()">
      @if ($currentView() === View.INTERESTS_AND_PUEBLOS) {
        Create
      } @else {
        Next
      }
    </button>
  </div>
</div>

<form [formGroup]="form" class="hang-form">
  <transition-view-container
    [views]="views"
    [view]="$currentView()"
    height="auto"
  >
    <transition-view [view]="View.DETAILS">
      <ng-container viewBody>
        <div class="title-medium">Details</div>
        <suboption-form
          class="no-scrollbar"
          [form]="form"
          [enabledOptions]="[
            SubOption.TITLE,
            SubOption.LOCATION,
            SubOption.DETAILS,
            SubOption.LINK,
          ]"
          [initialOptionsVisible]="[SubOption.TITLE, SubOption.LOCATION]"
          [alwaysVisibleSubOptions]="[SubOption.TITLE, SubOption.LOCATION]"
        ></suboption-form>

        <div class="section-title title-small on-surface-text">Visibility</div>
        <mat-chip-listbox
          formControlName="visibility"
          class="hang-visibility-chips"
        >
          <mat-chip-option
            [value]="Visibility.PUBLIC"
            (selectionChange)="publicVisibilitySelected($event)"
          >
            <mat-icon matChipAvatar>public</mat-icon>
            <div class="chip-content">
              <span class="title-medium">Public</span>
              <span class="body-small line"> Fully discoverable </span>
            </div>
          </mat-chip-option>
          <mat-chip-option
            [value]="Visibility.PRIVATE"
            (selectionChange)="privateVisibilitySelected($event)"
          >
            <mat-icon matChipAvatar>lock</mat-icon>
            <div class="chip-content">
              <span class="title-medium">Pueblos-only</span>
              <span class="body-small line"> Visible in Pueblos </span>
            </div>
          </mat-chip-option>
        </mat-chip-listbox>

        <mat-form-field
          appearance="outline"
          subscriptSizing="dynamic"
          class="time-field"
        >
          <mat-label>Date & Time</mat-label>
          <input
            #timeInput
            matInput
            readonly
            [matDatepicker]="datepicker"
            [min]="minDate"
            (dateChange)="changeDate($event)"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="datepicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #datepicker></mat-datepicker>
        </mat-form-field>
        <time-select [formControl]="form.controls.time"></time-select>
      </ng-container>
    </transition-view>

    <transition-view [view]="View.INTERESTS_AND_PUEBLOS">
      <ng-container viewBody>
        <div class="title-medium share-and-notify">Share and Notify</div>

        <interest-select
          [formPath]="['interests']"
          [users]="$puebloMembers()"
          [showCountBadge]="$showInterestCountBadge()"
        ></interest-select>

        <div
          class="section-title title-small on-surface-text justify-space-between"
        >
          Post in Pueblos
          <button mat-button (click)="$currentView.set(View.NEW_PUEBLO)">
            <mat-icon>add</mat-icon>
            New
          </button>
        </div>
        <pueblo-select
          class="pueblo-select"
          [formPath]="['pueblos']"
          [notifyInterestDisabled]="!$interestsChanges()?.length"
          class="no-scrollbar"
        ></pueblo-select>

        <div class="section-title title-small on-surface-text">
          To be notified
        </div>
        <user-list [users]="$usersToNotify()" expandable maxHeight="300px">
          <span class="body-medium"> No one </span>
        </user-list>
      </ng-container>
    </transition-view>

    <transition-view [view]="View.NEW_PUEBLO">
      <ng-container viewHeader>
        <div class="title-large on-surface-text pueblo-font new-pueblo-header">
          New Pueblo
        </div>
      </ng-container>
      <ng-container viewBody>
        <pueblo-form
          #newPuebloForm
          [hideTitle]="true"
          [hideFormActions]="true"
          (puebloCreated)="puebloCreated($event)"
        ></pueblo-form>
      </ng-container>
    </transition-view>
  </transition-view-container>
</form>
